/**
 * SNES Chat - Main Entry Point
 *
 * Initializes the application and mounts it to the DOM.
 */

import { initApp } from './app';

// Initialize the app when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  const appElement = document.getElementById('app');
  if (!appElement) {
    console.error('[SNES Chat] App container #app not found');
    return;
  }

  initApp(appElement);
});
